import React from "react";
import { FaCheckCircle } from "react-icons/fa";

interface ConversationTypeContentItemProps {
    title: string;
    description: string[];
    imageURL: string;
}

type ConversationTypeContentProps = Record<string, ConversationTypeContentItemProps>;

export const conversationTypeContentInput: ConversationTypeContentProps = {
    marketing: {
        title: "Marketing",
        description: ["Primarily used for transmitting promotional messages to customers.", "Examples: Abandoned cart texts, discount codes, and re-targeting messages."],
        imageURL: "https://assets.gallabox.com/gb-home/wa-pricing-calculator/convo-type/marketing.png",
    },
    utility: {
        title: "Utility",
        description: [
            "Used to keep customers up-to-date about a transaction or assist post-purchase.",
            "Examples: Post-purchase notifications, recurring billing statements, and more.",
        ],
        imageURL: "https://assets.gallabox.com/gb-home/wa-pricing-calculator/convo-type/utility.png",
    },
    authentication: {
        title: "Authentication",
        description: ["Delivers one-time notifications or passcodes during account set-up or log-in.", "Examples: Account verification codes and password reset notifications"],
        imageURL: "https://assets.gallabox.com/gb-home/wa-pricing-calculator/convo-type/authentication.png",
    },
    service: {
        title: "Service",
        description: [
            "User-initiated conversations, primarily customer service requests.",
            "Free unlimited customer-initiated messages with a 24 hour timeline for businesses to send free non-template replies.",
        ],
        imageURL: "https://assets.gallabox.com/gb-home/wa-pricing-calculator/convo-type/service.png",
    },
};

export const conversationTypeInput: string[] = Object.keys(conversationTypeContentInput);

interface ConvoTypeProps {
    conversationType: string;
}

const ConversationTypeContent: React.FC<ConvoTypeProps> = (props) => {
    const { conversationType } = props;
    return (
        <div className="flex flex-col gap-4 px-4 md:px-0 mt-8">
            <h5 className="text-xl font-bold text-gray-700 text-center md:text-left">{conversationTypeContentInput[conversationType].title}</h5>
            <div className="flex flex-col gap-2">
                {conversationTypeContentInput[conversationType].description.map((desc, index) => (
                    <div key={index} className="flex items-start gap-2">
                        <FaCheckCircle size="18px" className="mt-1 " style={{ color: "#01C853" }} />
                        <p className="text-xl font-normal text-gray-900 flex-1">{desc}</p>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ConversationTypeContent;
